<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('locationStorage.location')
            }}</label>
            <a-select
              v-model="model.location_id"
              style="width: 100%; height: 35px"
              :show-search="true"
              option-filter-prop="children"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :class="{ 'is-invalid': errors.has('location_id') }"
            >
              <a-select-option
                v-for="(location, index) in locations"
                :key="index"
                :value="location.location_id"
              >
                {{ location.location_name_en }}
              </a-select-option></a-select
            >
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('location_id')"
            >
              {{ errors.first('location_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('locationStorage.nameEn')
            }}</label>
            <input
              v-model="model.storage_name_en"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('storage_name_en') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('storage_name_en')"
            >
              {{ errors.first('storage_name_en') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('locationStorage.nameKh') }}</label>
            <input
              v-model="model.storage_name_kh"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('storage_name_kh') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('storage_name_kh')"
            >
              {{ errors.first('storage_name_kh') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'productGroupForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      loading: false,
      locations: [],
      model: {
        warehouse_storage_id: 0,
        location_id: null,
        storage_name_kh: null,
        storage_name_en: null,
      },
    }
  },
  async created() {
    await this.getLocations()
    this.setEditData()
  },
  computed: {
    ...mapState('product/locationStorage', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
  },
  methods: {
    ...mapActions('product/locationStorage', ['getLocation']),
    getLocations() {
      this.loading = true
      this.getLocation()
        .then((response) => {
          this.locations = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('product/locationStorage/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('product/locationStorage/update', {
          id: this.model.warehouse_storage_id,
          data: this.model,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.warehouse_storage_id = this.edit_data.warehouse_storage_id
        this.model.location_id = this.edit_data.location_id
        this.model.storage_name_kh = this.edit_data.storage_name_kh
        this.model.storage_name_en = this.edit_data.storage_name_en
      }
    },
  },
}
</script>
